export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 04 Food Court Calling.c4de262b.mp3";